<template>
  <div v-if="ready" class="c-main-container">

    <div class="main-container">

      <div class="kids-info">
        <i class="far fa-child" :class="kidsColor(info.sex)"></i> {{info.name}}
      </div>

      <div class="pay-info">
        <div class="icon">
          <img src="/images/icn_paycoin.svg">
        </div>
        <div class="text">
          {{info.pay.pay}}ペイ
        </div>
      </div>

    </div>

    <div class="promises-container">
      <div class="head">
        <img src="/images/icn_smile.svg"><span>つかう・ためる</span>
      </div>
      <PromisesListView :data="info.promises"/>
    </div>

    <div class="info-container">
      <div><i class="fal fa-info-circle"></i> りれき</div>
      <div v-if="Object.keys(info.log).length >= 1">
        <div v-for="(v,i) in info.log" :key="i">

          <div class="log">
            <span v-if="v.pay >= 1" class="head">もらった:</span>
            <span v-else class="head">つかった:</span>
            <span class="date">{{v.date}}</span>
            <span class="pay">{{v.pay}}ペイ</span>
            <span class="note">{{v.note}}</span>
          </div>
        </div>

      </div>
      <div v-else class="no-logs">
        りれきはありません
      </div>

    </div>

    <div class="info-container">
      <div>
        もらったペイ: {{info.pay.get}}ペイ
      </div>
      <div>
        つかったペイ: {{info.pay.use}}ペイ
      </div>
    </div>

    <div class="home-icon-container-header">
      <span @click="howToToggle">
        <i class="fal fa-info-circle"></i> ホーム画面にアイコンを追加しよう！
      </span>
    </div>
    <div v-if="showHowTo" class="home-icon-container">
      safariの場合<br>
      <div class="tACenter">・真ん中のアイコンをタップ</div>
      <img src="/images/home_icon1.png" class="img">
      <br>
      <div class="tACenter">・「ホーム画面に追加」を選ぶ</div>
      <img src="/images/home_icon2.png" class="img">
    </div>

    <div class="kv-image">
      <img src="/images/top-mv-kids.svg" alt="KIDS">
    </div>

  </div>
</template>

<script>

import PromisesListView from '@/components/project/PromisesListView';

export default {
  components: {
    PromisesListView
  },
  data () {
    return {
      ready: false,
      store: 'kids',
      lock: false,
      info: {},
      code: '',
      qrcodeText: '',
      showHowTo: false
    };
  },
  created: function () {
    this.initialize();
  },
  watch: {
    '$route' () {
      this.initialize();
    },
    lock: function () {

      // ローディング表示
      if (this.lock === true) {
        this.$store.dispatch('loading/open').then();
      } else {
        this.$store.dispatch('loading/close').then();
      }

    },
  },
  computed: {
    callbackDispatcher: function () {
      return this.$store.getters['message/callback'];
    },
  },
  methods: {
    initialize: function () {
      console.log('initialize');

      this.getInfo();
    },
    getInfo: function () {
      console.log('getInfo');

      this.ready = false;

      if (this.lock) {
        console.log('lock', this.lock);
        return;
      }

      this.lock = true;

      this.code = this.$route.params.code;

      let param = {
        code: this.code,
        s: this.$store.getters['auth/session']
      };

      this.$store.dispatch(this.store + '/code2info', param).then(() => {

        let status = this.$store.getters[this.store + '/status'];
        // console.log(status);

        if (status === 200) {

          this.info = this.$store.getters[this.store + '/info'];
          console.log(this.info);

          this.qrcodeText = process.env.VUE_APP_URL + 'kids/' + this.info.code;

          this.ready = true;

        } else {
          this.$store.dispatch('errorInfo/setErrorStore', this.store).then();
          this.$router.push({name: 'UserSystemError'});
        }

        // ロック解除
        this.lock = false;

      }).catch((err) => {
        console.log(err);

        // ロック解除
        this.lock = false;

        this.$store.dispatch('errorInfo/setSystemErrorMessage').then();
        this.$router.push({name: 'UserSystemError'});

      });

    },
    howToToggle: function () {
      if (this.showHowTo) {
        this.showHowTo = false;
      } else {
        this.showHowTo = true;
      }
    },
    kidsColor: function (sex) {

      if(sex === 1){
        return 'boy';
      } else if(sex === 2){
        return 'girl';
      } else{
        return 'default';
      }
    }
  }
};

</script>

<style lang="scss" scoped>

  @import '../../../assets/styles/_variable.scss';

  .back-link {
    font-size: 25px;
  }

  .kids-info {
    text-align: center;
    font-size: 25px;
    border-bottom: 1px solid #ddd;
  }

  .pay-info {
    width: 300px;
    margin: 10px auto;
    border: 1px solid $keyColor;
    border-radius: 20px;
    text-align: center;
    padding: 20px;

    .icon {
      img {
        width: 100px;
      }
    }

    .text {
      font-size: 30px;
      color: $keyColor;
      line-height: 30px;
      margin-top: 10px;
    }
  }

  .pay-operate-container {
    width: 300px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
  }

  .url-text {
    text-align: center;
    font-size: 12px;
  }

  .info-container {
    padding: 5px;
    border: 1px solid #ddd;
    border-radius: 3px;
    margin-bottom: 10px;
  }

  .promises-container {
    padding: 5px 5px 15px 10px;
    border: 1px solid #ddd;
    border-radius: 3px;
    margin-bottom: 10px;

    .head{
      display: flex;
      align-items: center;
      img {
        margin-right: 5px;
      }
    }
  }

  .fa-info-circle{
    color: $keyColor;
  }

  .log {
    font-size: 14px;

    .head {
      display: inline-block;
      width: 80px;
      padding-left: 5px;
    }

    .date {
      display: inline-block;
      width: 90px;
      padding-left: 5px;
    }

    .pay {
      display: inline-block;
      width: 70px;
      padding-left: 5px;
    }

    .note {
      padding-left: 5px;
    }

  }

  .no-logs {
    font-size: 14px;
  }

  .home-icon-container-header {
    margin-bottom: 5px;

    span {
      border-bottom: 1px solid #ddd;
      cursor: pointer;
    }
  }

  .kv-image{
    text-align: center;
    margin: 15px 10px;
  }


  .boy {
    color: #95DFD6;
  }

  .girl {
    color: #F3C0AB;
  }

  .default {
    color: #aaa;
  }

  // 801以上
  @media screen and (min-width: 801px) {

    .home-icon-container {
      border: 1px solid #ddd;
      border-radius: 6px;
      padding: 10px;

      .img {
        display: block;
        margin: 0 auto;
      }
    }

  }

  // 800まで
  @media screen and (max-width: 800px) {

    .home-icon-container {
      border: 1px solid #ddd;
      border-radius: 6px;
      padding: 10px;

      .img {
        width: 80%;
        display: block;
        margin: 0 auto;
      }
    }
  }

</style>
